<script setup lang="ts">
  import type { IModal } from '@/components/ui/modal/types'

  const props = defineProps<{
    blok?: IModal
    modalTitle?: string
    modalContent?: string
  }>()

  const isOpen = defineModel<boolean>()

  const title = computed(() => props.modalTitle ?? props.blok?.modalTitle ?? '')
  const content = computed(() => props.modalContent ?? props.blok?.modalContent ?? '')
</script>

<template>
  <DialogRoot
    v-if="content?.length"
    v-model:open="isOpen"
  >
    <DialogPortal>
      <DialogOverlay class="fixed inset-0 z-30 bg-black/75" />
      <DialogContent
        class="fixed left-1/2 top-0 z-40 h-dvh w-full -translate-x-1/2 bg-white p-4 md:top-10 md:h-[85%] md:w-186 md:translate-y-10 md:rounded-sm md:p-8"
      >
        <div class="mb-2 flex items-start justify-between gap-2 md:mb-4">
          <DialogTitle
            v-if="title"
            as="h5"
            class="mb-0"
          >
            {{ title }}
          </DialogTitle>

          <DialogClose :aria-label="$t('close')">
            <Icon
              class="text-bt-blue-dark"
              name="common/close"
            />
          </DialogClose>
        </div>
        <div
          class="h-full max-h-[95%] overflow-y-auto pr-4 md:max-h-[85%]"
          v-html="content"
        />
      </DialogContent>
    </DialogPortal>
  </DialogRoot>
</template>
